module.exports = __webpack_public_path__ + "img/t5_i_two.9e418626.png";